import { Module } from 'vuex'
import axios from 'axios'
import { BASE_API_URL } from '@/config'

export enum SensorType {
  ANALOG = 'ANALOG',
  DIGITAL = 'DIGITAL'
}
export interface Sensor {
  id: number
  name: string
  scale: number
  unit: string
  type: SensorType
}
export type AddSensor = Pick<Sensor, 'name' | 'unit' | 'type' | 'scale'>
export type EditSensor = Sensor
export interface SensorStore {
  sensors: Sensor[]
}

export const sensorStore: Module<SensorStore, {}> = {
  namespaced: true,
  state: () => ({
    sensors: []
  }),
  mutations: {
    loadSensors(state, payload: Sensor[]) {
      state.sensors = payload
    }
  },
  actions: {
    async loadSensors({ commit }) {
      const { data } = await axios(`${BASE_API_URL}/sensor`)
      commit('loadSensors', data)
    },
    async addSensor(_, payload: AddSensor) {
      const { data } = await axios.post(`${BASE_API_URL}/sensor`, payload)
      return data
    },
    async editSensor({ dispatch }, { id, ...sensor }: EditSensor) {
      const { data } = await axios.put(`${BASE_API_URL}/sensor/${id}`, sensor)
      await dispatch('loadSensors')
      return data
    },
    async getSensor(_, id: string) {
      const { data } = await axios.get(`${BASE_API_URL}/sensor/${id}`)
      return data
    }
  },
  getters: {
    sensors: state => state.sensors
  }
}
